<template>
    <div>
      <head-top v-on:navClick="navClickFun" :navActive="navActive"></head-top>
      <!-- 内容 start -->
      <div class="description-first-bg"></div>
      <div class="system-detail-main">
        <p class="bread-crumb-nav">
          <i><img src="../../static/img/ts-img/address-icon.png" width="13"></i>
          <span>当前位置：</span>
          <router-link :to="{path:'/'}"> 首页 ></router-link>
          <router-link :to="{path:'/chSystem/'}">中国学术不端查重系统 ></router-link>
          <a class="current">{{productInner.name}}</a>
        </p>
        <!-- 上半部分 start -->
        <div class="system-detail-top">
          <div class="system-detail-top-img"><img :src="productInner.img" width="400"></div>
          <div class="system-detail-top-right">
            <h3>{{productInner.name}}</h3>
            <p class="desc">{{productInner.desc}}</p>
            <div class="system-detail-top-price">
              <p class="price">{{productInner.price}}<span>元/篇</span></p>
              <b class="people">适用人群：{{productInner.intended_for}}</b>
            </div>
            <div class="system-detail-top-btn">
              <span v-if="productInner.id==null" @click="NullFun">立即检测</span>
              <span v-if="productInner.id!=null" @click="btnClickFun(productInner.id)">立即检测</span>
              <span><router-link to="/reportDownload/">下载报告</router-link></span>
            </div>
          </div>
        </div>
        <!-- 上半部分 end -->
        <!-- 下半部分 start -->
        <div class="system-detail-bottom">
          <div class="segmented-control">
            <a :class="contentNum == 1 ? 'active' : ''" @click="controlNavFun(1)">产品详情</a>
            <a :class="contentNum == 2 ? 'active' : ''" @click="controlNavFun(2)">演示报告</a>
            <a :class="contentNum == 3 ? 'active' : ''" @click="controlNavFun(3)">累计评价</a>
          </div>
          <div class="control-content">
            <product-detail v-if="contentNum == 1" :demonReport="explain"></product-detail>
            <product-report v-if="contentNum == 2" :explain="demon_report"></product-report>
            <product-evaluate v-if="contentNum == 3" :goods_evaluation="goods_evaluation"></product-evaluate>
          </div>
        </div>
        <!-- 下半部分 end -->
      </div>
      <!-- 内容 end -->
      <foot-bottom></foot-bottom>
    </div>
</template>

<script>
  import headTop from '../components/header/head-top'
  import footBottom from '../components/footer/foot-bottom'
  import productDetail from '../components/system-com/system-detail'
  import productReport from '../components/system-com/product-report'
  import productEvaluate from '../components/system-com/product-evaluate'
  import tool from '../assets/js/tool.js'
    export default {
        name: "ch-system-detail",
        data () {
          return {
            navActive: 2,
            contentNum: 1, //当前选择的是哪项
            productInner: '', //获取的产品信息
            demon_report:'',
            explain:'',
            goods_evaluation:''
          }
        },
        components: {
          headTop,
          footBottom,
          productDetail,
          productReport,
          productEvaluate
        },
        methods: {
          controlNavFun (num){
            this.contentNum = num;
          },
             btnClickFun (id) {
            this.$router.push({
              path: '/paperUpload/',
              query:{
                id:id
              }
            })
          },
          navClickFun (inner) {
            this.productInner = inner;
            this.demon_report = inner.demon_report;
            this.explain = inner.explain;
            this.goods_evaluation = inner.goods_evaluation
          },
          NullFun(){
            this.$message({
              type: 'success',
              message: '请等待页面加载完毕后点击“立即检测”'
            });
          }
        },
        mounted () {
          let data = {
            goods_id: this.$route.query.id
          };
          tool.postData('get_goods_detail',data,(res) => {
            this.productInner = res.data.data;
            this.demon_report = res.data.data.demon_report;
            this.explain = res.data.data.description;
            this.goods_evaluation = res.data.data.goods_evaluation
          });
        },
    }
</script>

<style scoped lang="scss">
  @import "../assets/style/common";
  .description-first-bg{
    width: 100%;
    height: 80px;
    background: url("../../static/img/nav.png");
  }
  .system-detail-main{
    width: $box-width;
    margin: 0 auto;
    .bread-crumb-nav{
      line-height: 83px;
      span{
        @include font(18px,#666)
      }
      a{
        @include font(18px,#666);
        &.current{
          color: #3b6bda;
        }
      }
    }
    .system-detail-top{
      display: flex;
      align-items: flex-end;
      margin-bottom: 70px;
      .system-detail-top-img{
        width: 400px;
        height: 250px;
        border-radius: 10px;
        overflow: hidden;
      }
      .system-detail-top-right{
        width: 583px;
        margin-left: 25px;
        h3{
          @include font(30px,#333);
          line-height: 65px;
        }
        .desc{
          @include font(16px,#666);
          line-height: 25px;
        }
        .system-detail-top-price{
          display: flex;
          align-items: flex-end;
          margin-top: 24px;
          margin-bottom: 24px;
          .price{
            @include font(36px,#3b6bda);
            span{
              @include font(16px,#333);
            }
          }
          .people{
            @include font(16px,#3b6bda);
            margin-left: 20px;
          }
        }
        .system-detail-top-btn{
          width: 350px;
          height: 39px;
          @include flex;
          span{
            cursor: pointer;
            width: 160px;
            height: 39px;
            border-radius: 20px;
            text-align: center;
            line-height: 39px;
            cursor: ·;
            @include font(20px,#fff);
            &:first-child{
              background-color: #3b6bda;
            }
            &:last-child{
              background-color: #dc6974;
              a{
                color: #fff;
              }
            }
          }
        }
      }
    }
    .system-detail-bottom{
      padding-bottom: 75px;
      .segmented-control{
        border-bottom: 1px solid #b1c4f0;
        padding-bottom: 30px;
        display: flex;
        a{
          width: 188px;
          line-height: 57px;
          text-align: center;
          border: 2px solid #3b6bda;
          border-radius: 10px;
          @include font(24px,#3b6bda);
          margin-right: 20px;
          cursor: pointer;
          &.active{
            background-color: #3b6bda;
            color: #fff;
          }
        }
      }
      .control-content{
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/ch-system-detail.vue